import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import { spreadDangerousChildren } from "../utils/spreadDangerousChildren";
var cn = classNames.bind(styles);

/** компонент используется для простановки ошибки/хэлпер текста под инпутами */
export var MessageText = /*#__PURE__*/memo(function (_ref) {
  var helpMessage = _ref.helpMessage,
    errorMessage = _ref.errorMessage,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('message', {
      'message--help': helpMessage && !errorMessage
    }, className),
    "data-t-id": "src-MessageText"
  }, /*#__PURE__*/React.createElement("span", spreadDangerousChildren(errorMessage || helpMessage)));
});
MessageText.displayName = MessageText.name;